import Vue from 'vue/dist/vue.common';
import { debounce } from "debounce";
import $ from 'jquery';
import { parse } from 'node-html-parser';

const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);


// import '../../../node_modules/bootstrap/js/src/tooltip';

// $(document).ready(function () {
// 	$('[data-toggle="tooltip"]').tooltip();
// })

// import "@fortawesome/fontawesome-free/js/all";
// window.FontAwesomeConfig = {
// 	searchPseudoElements: true
// }

$.ajaxSetup({
	headers: {
		'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
	}
});

function defaultLesson() {
	return {
		id: -1,
		name: 'Not Selected',
		membership: false,
		free: false,
		showMenu: false,
		parent: {
			showMenu: false,
			lessons: [],
			height: 0,
			parent: {
				showMenu: false,
			}
		}
	}
}

Vue.prototype.$bus = new Vue();

const courseSideMenu = new Vue({
	el: '#course-side-menu',
	data: {
		currentContent: null,
		courses: [],
		filteredCourses: [],
		sideMenuOpen: false,
		searchTerm: '',
		signedIn: signedIn,
		sold_course_max_level: sold_course_max_level,
		currentLesson: defaultLesson(),
		player: null,
	},
	methods: {
		GetLesson: function (lesson) {
			this.sideMenuOpen = false;

			// while(this.currentContent.firstChild){
			// 	div.removeChild(div.firstChild);
			// }
			// this.player = null;

			console.log(lesson.id, 'lesson')
			console.log(courseSlug, 'courseSlug')
			$.get('/course/' + courseSlug + '/get-lesson/' + lesson.id, async response => {
				if (response.state) {
					const dom = parse(response.content.replace('\r\n', ''));


					// const $content = $('<div>' + response.content + '</div>');
					// const iframeInContent = $content.find('#video_player iframe');
					const iframeInContent = dom.querySelector('#video_player iframe');
					if (iframeInContent) {
						// iframeInContent.attr('src', iframeInContent.attr('src') + "?playsinline=1listType=user_uploads&iv_load_policy=3&modestbranding=1&rel=0&showinfo=0")
						iframeInContent.attributes.src = iframeInContent.attributes.src + "?playsinline=1listType=user_uploads&iv_load_policy=3&modestbranding=1&rel=0&showinfo=0";
					}

					// $content.find('[contenteditable]').removeAttr('contenteditable');
					dom.querySelectorAll('[contenteditable]').forEach(ce => ce.removeAttribute('contenteditable'));

					// $content.find('audio').each(function () {
					const audios = dom.querySelectorAll('audio');
					console.log(audios, 'audios')
					for (const audio of audios) {
						// audio.attr('preload', 'none');
						// audio.attr('onplay', 'playerLoadStart(event)');
						// audio.attr('oncanplaythrough', 'playerCanPlayThrough(event)');
						if (isSafari) {
							const div = parse(`<div id="player" src="${audio.attributes.src}" style="display: none;"></div>`);
							audio.replaceWith(div);
						}
						else {
							// audio.setAttribute('preload', 'none');
							audio.setAttribute('onplay', 'playerLoadStart(event)');
							audio.setAttribute('oncanplaythrough', 'playerCanPlayThrough(event)');
						}
					}
					// this.currentContent.innerHTML = $content.html();
					this.currentContent.innerHTML = dom.toString();

					await Vue.nextTick();
					this.player = document.getElementById('video_player');
					if (this.player) {
						const iframe = this.player.querySelector('iframe');
						if (iframe) {
							iframe.setAttribute('playsinline', '1');
							iframe.setAttribute('controls', '0');
							iframe.setAttribute('iv_load_policy', '3');
							iframe.setAttribute('modestbranding', '1');
							iframe.setAttribute('rel', '0');
							iframe.setAttribute('showinfo', '0');
						}
					}
					history.pushState(dom.toString(), lesson.title, '?lesson=' + lesson.id);
				}
				else {
					this.player = null;
					const $content = $(`
					<div>
						<div class="col-12">
							<div class="alert alert-secondary" role="alert">
								<div class="h6 mb-0">${response.content}</div>
							</div>
						</div>
					</div>
					`);
					document.getElementById('currentContent').innerHTML = $content.html();
					history.pushState($content.html(), lesson.title, '?lesson=' + lesson.id);
				}
			})
		},
		ToggleMenu: function (menuItem, event) {
			const showMenu = menuItem.showMenu;
			this.$set(menuItem, 'showMenu', !showMenu)
			setTimeout(() => {
				this.$refs.course_menu.scrollTop = event.target.offsetTop - 90;
			}, 300);
		},
		ToggleSideMenu: function () {
			this.sideMenuOpen = !this.sideMenuOpen;
		},
		FilterMenu: function () {
			const search = new RegExp(this.searchTerm.toLocaleLowerCase(), 'gm');

			const reformatcourses = this.courses.map(course => ({
				...course,
				levels: course.levels.map(level => ({
					...level,
					sections: level.sections.map(section => ({
						...section,
						lessons: section.lessons.filter(lesson => {
							return search.test(lesson.title.toLocaleLowerCase());
						})
					})).filter(section => section.lessons.length > 0)
				})).filter(level => level.sections.length > 0),
			}));

			this.filteredCourses = reformatcourses;
		},
		ScrollHandler: function (e) {
			console.log('ScrollHandler', e)
			const scrollTop = document.scrollingElement.scrollTop;
			console.log(this.scrollStatus, 'this.scrollStatus', scrollTop, 'scrollTop')

			if (!this.scrollStatus && scrollTop > 30) {
				this.scrollStatus = true;
				this.player.classList.add('fixed-to-top-video');
				this.player.classList.add('add_fixed_video_border');
				this.$refs.course_menu.classList.add('scrolled');
				this.player.style.width = this.$refs.course_menu.offsetWidth + "px";
				this.sideMenuOpen = false;
			}
			else if (this.scrollStatus && scrollTop <= 30) {
				this.scrollStatus = false;
				this.player.classList.remove('fixed-to-top-video');
				this.player.classList.remove('add_fixed_video_border');
				this.$refs.course_menu.classList.remove('scrolled');
				this.player.style.width = '';
				this.sideMenuOpen = true;
			}
		},
		menuHeight: function (menuItem) {
			if (!menuItem) {
				return false;
			}
			return 0;
			let height = menuItem.height;
			while ((parent = menuItem.parent)) {
				height += parent.height;
			}
			return height;
		},
		sectionHeight: function (section) {
			return section.showMenu ? section.height : 0;
		},
		levelHeight: function (level) {
			return level.showMenu ? level.height + level.sections.filter(x => x.showMenu).reduce((o, n) => o + this.sectionHeight(n), 0) : 0;
		},
		courseHeight: function (course) {
			return course.showMenu ? course.height + course.levels.filter(x => x.showMenu).reduce((o, n) => o + this.levelHeight(n), 0) : 0;
		},
		SetCurrentLesson: function (lesson) {
			// this.currentContent = null;
			this.currentLesson = lesson;
		},
	},
	computed: {
	},
	watch: {
		currentLesson: function (lesson, oldLesson) {
			oldLesson.parent.showMenu = false;
			lesson.parent.parent.showMenu = true;
			lesson.parent.showMenu = true;
			console.log('currentLesson', lesson)
			this.GetLesson(lesson);
			this.$bus.$emit('currentLesson', lesson);
		},
		searchTerm: function () {
			this.FilterMenu();
		}
	},
	mounted: function () {

	},
	beforeUnmount: function () {
		console.log('beforeUnmount')
	},
	created() {
		this.currentContent = document.getElementById('currentContent');

		const pageUrl = new URL(window.location.href);
		const lessonId = parseInt(pageUrl.searchParams.get('lesson'));
		let currentLesson;
		const reformatcourses = courses.map(course => {
			levels: course.levels.map(level => {
				level.sections = level.sections.map(section => {
					section.lessons = section.lessons.map(lesson => {
						lesson.parent = section;
						lesson.showMenu = false;
						if (lessonId === lesson.id) {
							currentLesson = lesson;
						}
						return lesson;
					});
					section.parent = level;
					section.showMenu = false;
					section.height = section.lessons.length * 6.5;
					return section;
				});
				level.parent = course;
				level.showMenu = false;
				level.height = level.sections.length * 6.5;
				return level;
			}),
				course.height = course.levels.length * 6.5;
			course.showMenu = true;
			return course;
		});
		this.filteredCourses = reformatcourses;
		this.courses = reformatcourses;
		if (currentLesson) {
			console.log('currentLesson', currentLesson)
			this.currentLesson = currentLesson;
		}
		else if (
			reformatcourses.length &&
			reformatcourses[0].levels.length &&
			reformatcourses[0].levels[0].sections.length &&
			reformatcourses[0].levels[0].sections[0].lessons.length
		) {
			this.currentLesson = reformatcourses[0].levels[0].sections[0].lessons[0];
		}
		this.debouncedScrollHandler = debounce(this.ScrollHandler, 200);
		window.addEventListener('scroll', this.debouncedScrollHandler);
		this.$bus.$on("currentLesson", this.SetCurrentLesson);
		this.$bus.$on("menuToggle", this.ToggleSideMenu);
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.debouncedScrollHandler);
		this.$bus.$off("currentLesson", this.SetCurrentLesson);
		this.$bus.$off("menuToggle", this.ToggleSideMenu);
	}

})



const toggleMenu = new Vue({
	el: '#toggle-menu',
	methods: {
		ToggleSideMenu: function () {
			this.$bus.$emit('menuToggle');
		},
	}
})

new Vue({
	el: '#course-title',
	data: {
		currentLesson: defaultLesson(),
	},
	methods: {
		SetCurrentLesson: function (lesson) {
			this.currentLesson = lesson;
		},
	},
	created() {
		this.$bus.$on("currentLesson", this.SetCurrentLesson);
	},
	beforeDestroy() {
		this.$bus.$off("currentLesson", this.SetCurrentLesson);
	}
})



// const toggleMenu = new Vue({
// 	el: '#toggle-menu',
// 	methods: {
// 		ToggleMenu: function (menuItem, event) {
// 			const showMenu = menuItem.showMenu;
// 			this.$set(menuItem, 'showMenu', !showMenu)
// 			setTimeout(() => {
// 				this.$refs.course_menu.scrollTop = event.target.offsetTop - 90;
// 			}, 300);
// 			// this.$set(menuItem, 'height', showMenu ? menuItem.height : 0)
// 		},
// 	}
// })






Vue.component("course-navigation", {
	name: "course-navigation",
	template: `
	<div class="row justify-content-between">
		<div class="col-auto">
			<button type="button" class="btn btn-link btn-lesson-nav" @click="PrevLesson" v-if="prevLesson">
				<i class="fas fa-angle-left"></i> ÖNCEKİ DERS
			</button>
		</div>
		<div class="col-auto">
			<button type="button" class="btn btn-link btn-lesson-nav" @click="NextLesson" v-if="nextLesson">SONRAKİ DERS
				<i class="fas fa-angle-right"></i></button>
		</div>
	</div>
`,
	data: function () {
		return {
			currentLesson: defaultLesson(),
		}
	},
	methods: {
		PrevLesson: function () {
			const lessons = this.currentLesson.parent.lessons;
			const index = lessons.findIndex(lesson => lesson.id === this.currentLesson.id);
			this.currentLesson = lessons[index - 1];
			this.$bus.$emit("currentLesson", this.currentLesson);
		},
		NextLesson: function () {
			const lessons = this.currentLesson.parent.lessons;
			const index = lessons.findIndex(lesson => lesson.id === this.currentLesson.id);
			this.currentLesson = lessons[index + 1];
			this.$bus.$emit("currentLesson", this.currentLesson);
		},
		ChangeCurrentLesson: function (lesson) {
			this.currentLesson = lesson;
		}
	},
	computed: {
		prevLesson: function () {
			if (!this.currentLesson) {
				return false
			}
			return this.currentLesson.parent.lessons.findIndex(lesson => lesson.id === this.currentLesson.id) > 0
		},
		nextLesson: function () {
			if (!this.currentLesson) {
				return false
			}
			const lessons = this.currentLesson.parent.lessons;
			return lessons.findIndex(lesson => lesson.id === this.currentLesson.id) < (lessons.length - 1)
		},
	},
	watch: {
		currentLesson: function (lesson) {
			console.log(lesson, 'lesson');
			console.log(this.currentLesson, 'this.currentLesson watcher');
		}
	},
	created() {
		this.$bus.$on("currentLesson", this.ChangeCurrentLesson);
	},
	beforeDestroy() {
		this.$bus.$off("currentLesson", this.ChangeCurrentLesson);
	}
})

new Vue({
	el: "#navigation-top",
	data: {},

})
new Vue({
	el: "#navigation-bottom",
	data: {},
})

window.basic_player = function (event) {
	console.log(event.target, 'event.target');
	console.log(event.currentTarget, 'event.currentTarget');
	let player = event.currentTarget.parentElement.querySelector('#player');
	if (!player) {
		return;
	}

	if (isSafari) {
		const audio = document.createElement('audio');
		audio.setAttribute('id', 'player');
		audio.setAttribute('preload', 'none');
		audio.setAttribute('src', player.getAttribute('src'));
		audio.setAttribute('onplay', 'playerLoadStart(event)');
		audio.setAttribute('oncanplaythrough', 'playerCanPlayThrough(event)');
		player.replaceWith(audio);
		player = audio;
	}

	if (player.paused || player.ended) {
		player.play();
		event.currentTarget.classList.remove('fa-play');
		event.currentTarget.classList.add('fa-pause');
	}
	else {
		player.pause();
		player.currentTime = 0;
		event.currentTarget.classList.remove('fa-pause');
		event.currentTarget.classList.add('fa-play');
	}
}

window.audio_ended = function (event) {
	event.target.parentElement.querySelector('.btn-play').classList.remove('fa-pause');
	event.target.parentElement.querySelector('.btn-play').classList.add('fa-play');
	event.target.parentElement.querySelector('.btn-play').setAttribute('data-loading', 'false')
};

window.playerLoadStart = (event) => {
	const audio = $(event.target);
	const button = audio.parent().find('.btn-play');
	if (!button.attr('data-loading')) {
		button.attr('data-loading', 'true');
	}
};

window.playerCanPlayThrough = (event) => {
	const audio = $(event.target);
	audio.parent().find('.btn-play').attr('data-loading', 'false');
};

window.showToolBox = () => undefined;
window.basic_audio_upload = () => undefined;
window.show_remove_row_button = () => undefined;
window.show_remove_p_button = () => undefined;